import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["disabled", "title", "aria-expanded"]
const _hoisted_2 = {
  key: 0,
  class: "workspace-options-card"
}
const _hoisted_3 = ["aria-checked", "onClick"]
const _hoisted_4 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
}
const _hoisted_5 = {
  key: 0,
  class: "workspace-empty"
}

import { nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import StudioIcon from "./StudioIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'StudioWorkspaceSelect',
  props: {
    modelValue: {},
    workspaces: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const root = ref<HTMLElement>();
const trigger = ref<HTMLButtonElement>();
const menu = ref<HTMLElement>();
const open = ref(false);

async function show(last = false) {
  if (props.disabled) return;
  open.value = true;
  await nextTick();
  if (!open.value) return;
  const options = menu.value?.querySelectorAll<HTMLButtonElement>('[role="menuitemradio"]');
  const selected = props.workspaces.indexOf(props.modelValue);
  options?.[last ? props.workspaces.length - 1 : Math.max(0, selected)]?.focus();
}
function close(restoreFocus = false) {
  open.value = false;
  if (restoreFocus) trigger.value?.focus();
}
function toggle() { if (open.value) close(); else void show(); }
function select(id: string) {
  if (props.disabled || !props.workspaces.includes(id)) return;
  close(true);
  // The parent updates modelValue only after the current editor has saved successfully.
  if (id !== props.modelValue) emit("select", id);
}
function onMenuKeydown(event: KeyboardEvent) {
  if (event.key === "Tab") { close(true); return; }
  const options = Array.from(menu.value?.querySelectorAll<HTMLButtonElement>('[role="menuitemradio"]') ?? []);
  if (!options.length) return;
  const index = options.indexOf(document.activeElement as HTMLButtonElement);
  let next: number;
  switch (event.key) {
    case "ArrowDown": next = (index + 1) % options.length; break;
    case "ArrowUp": next = (index - 1 + options.length) % options.length; break;
    case "Home": next = 0; break;
    case "End": next = options.length - 1; break;
    default: return;
  }
  event.preventDefault();
  options[next]?.focus();
}
function onFocusOut(event: FocusEvent) {
  if (!root.value?.contains(event.relatedTarget as Node | null)) close();
}
function onPointerDown(event: PointerEvent) {
  if (root.value && !event.composedPath().includes(root.value)) close();
}
watch(() => props.disabled, disabled => { if (disabled) close(); });
watch(() => props.modelValue, () => close());
onMounted(() => document.addEventListener("pointerdown", onPointerDown, true));
onBeforeUnmount(() => document.removeEventListener("pointerdown", onPointerDown, true));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "studio-workspace-select",
    onFocusout: onFocusOut,
    onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (close(true)), ["stop","prevent"]), ["esc"]))
  }, [
    _createElementVNode("button", {
      ref_key: "trigger",
      ref: trigger,
      type: "button",
      class: _normalizeClass(["workspace-trigger", { 'is-open': open.value }]),
      disabled: __props.disabled,
      "aria-label": "选择工作区",
      title: __props.modelValue || '选择工作区',
      "aria-haspopup": "menu",
      "aria-expanded": open.value,
      "aria-controls": "studio-workspace-options",
      onClick: toggle,
      onKeydown: [
        _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (show()), ["prevent"]), ["down"])),
        _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (show(true)), ["prevent"]), ["up"]))
      ]
    }, [
      _createVNode(StudioIcon, {
        name: "folder",
        size: 16
      }),
      _createElementVNode("span", null, _toDisplayString(__props.modelValue || '选择工作区'), 1),
      _cache[3] || (_cache[3] = _createElementVNode("svg", {
        class: "workspace-chevron",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", { d: "m6 9 6 6 6-6" })
      ], -1))
    ], 42, _hoisted_1),
    _createVNode(_Transition, { name: "workspace-menu" }, {
      default: _withCtx(() => [
        (open.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                id: "studio-workspace-options",
                ref_key: "menu",
                ref: menu,
                class: "workspace-options",
                role: "menu",
                "aria-label": "工作区列表",
                onKeydown: onMenuKeydown
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workspaces, (id) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: id,
                    type: "button",
                    class: _normalizeClass(["workspace-option", { 'is-selected': id === __props.modelValue }]),
                    role: "menuitemradio",
                    "aria-checked": id === __props.modelValue,
                    tabindex: "-1",
                    onClick: ($event: any) => (select(id))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(id), 1),
                    (id === __props.modelValue)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("path", { d: "m5 12 4 4L19 6" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_3))
                }), 128)),
                (!__props.workspaces.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, "暂无工作区，请点击右侧 ＋ 新建"))
                  : _createCommentVNode("", true)
              ], 544)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 544))
}
}

})